import React,{Component} from 'react';
import SelectLanguage from '../Common/SelectLanguage';
import Moment from 'react-moment';
import i18n from "../../i18n";
import {withTranslation } from 'react-i18next';
import {connect} from "react-redux";

export class Footer extends Component{

    render(){
        if(this.props.locale !== 'en'){
            let splittedLocale = this.props.locale.split('-');
            let goUrlLocale = "";
            if(splittedLocale.length === 2){
                goUrlLocale = splittedLocale[0] + "_" + splittedLocale[1].toUpperCase();
            }
            else {
                goUrlLocale = this.props.locale;
            }
            
            this.termsOfUseUrl = this.props.getStandardGoUrls.termsOfUseUrl + "_" + goUrlLocale;
            this.privacyUrl = this.props.getStandardGoUrls.privacyUrl + "_" + goUrlLocale;
            this.cookiesUrl = this.props.getStandardGoUrls.cookiesUrl + "_" + goUrlLocale;
            this.showAdChoiceLink = false;
        }
        else{
            this.termsOfUseUrl = this.props.getStandardGoUrls.termsOfUseUrl;
            this.privacyUrl = this.props.getStandardGoUrls.privacyUrl;
            this.cookiesUrl = this.props.getStandardGoUrls.cookiesUrl;
            this.showAdChoiceLink = true;
        }
        return(
            <footer data-am-id="footer">
                <div className="footer-info">
                    <a id="termsOfUse" href={this.termsOfUseUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.termsOfUse')}</a>
                    <a id="privacy" href={this.privacyUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.privacy')}</a>
                    <a id="cookies" href={this.cookiesUrl} target="_blank" rel="noopener noreferrer">{i18n.t('footer.cookies')}</a>
                    {this.showAdChoiceLink && <a href="http://info.evidon.com/pub_info/1413?v=1" target="_blank" rel="noopener noreferrer">{i18n.t('footer.adChoices')}</a>}
                    {!window.location.hash.includes('/agreements') && (
                        <span className="select-language-section">{i18n.t('footer.language')} <SelectLanguage/></span>
                    )}
                </div>
                <div className="copy-right">
                    © <Moment format="YYYY" date={new Date()} /> {i18n.t('footer.copyRight')}
                </div>
                <div className="clear-both"></div>
            </footer>
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        locale:state.LocaleReducer.goUrlLocale,
        getStandardGoUrls:state.AppReducer.getStandardGoUrls
    }
};

export default connect(mapStateToProps)(withTranslation()(Footer));
